<template>
    <div class="tc-sidebar-right-items-body-card">
        <img class="tc-sidebar-right-items-body-card-image"
             :src="getImage(itemPrototype.image)">
        <div class="tc-sidebar-right-items-body-card-button-anchor"
             v-if="isSeparatorsAvailable &&
             !storeCaseConfiguration.getIsDrawerExpandedByPrototypeId(item.prototypeId)">
            <div class="tc-sidebar-right-items-body-card-button"
                 v-on:click="storeCaseConfiguration.setDrawerExpandedByPrototypeId(item.prototypeId, true)">
                <SVGNewSeparator/>
            </div>
        </div>
        <div class="tc-sidebar-right-items-body-card-description">
            <div class="tc-sidebar-right-items-body-card-description-text"
                 :title="itemPrototype.name">
                {{itemPrototype.name}}
            </div>
            <div class="tc-sidebar-right-items-body-card-description-count">
                {{item.count}} шт.
            </div>
        </div>
    </div>
</template>

<script>
import SVGNewSeparator from '@/UI/SVG/SVGNewSeparator.vue';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { getPrototypeByID } from '@/libs/libraryGetters';
import { getImage } from '@/libs/getImage';

export default {
    name: 'ResultItemCardMain',
    components: {
        SVGNewSeparator,
    },
    setup() {
        const storeCaseConfiguration = useStoreCaseConfiguration();
        return {
            storeCaseConfiguration,
        };
    },
    props: [
        'item',
        'isSeparatorsAvailable',
    ],
    methods: {
        getPrototypeByID,
        getImage,
    },
    computed: {
        itemPrototype() {
            return this.getPrototypeByID(this.item.prototypeId);
        },
    },
};
</script>

<style scoped lang="scss">
@import "CSS/rigtSIdebarItems";
</style>
